import { render, staticRenderFns } from "./quotationOfprices.vue?vue&type=template&id=c355b95c&scoped=true"
import script from "./quotationOfprices.vue?vue&type=script&lang=js"
export * from "./quotationOfprices.vue?vue&type=script&lang=js"
import style0 from "./quotationOfprices.vue?vue&type=style&index=0&id=c355b95c&prod&lang=css"
import style1 from "./quotationOfprices.vue?vue&type=style&index=1&id=c355b95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c355b95c",
  null
  
)

export default component.exports